<template lang="pug">
v-layout.px-3(column)
  v-subheader.pl-1.mt-3.pb-3 {{ $tf("drawer.news.title") }}
  v-layout(column)
    template(v-for='(d, index) in news')
      v-card(:key="index + 1" avatar="" ripple="" @click="openNews(d.id)" style="max-width: 865px;")
        v-card-title
          div(style="display: flex;")
            div(style="flex: 1; margin-right: 10px;")
              img(class="preview-small-media-item" :src="d.thumbnailUrl")        
            div(style="flex: 6")
              div {{format_date(d.created)}}
              div.font-weight-medium(style="margin-bottom:2px;") {{locale === 'kk' ? getVariableValue('titleKaz', d._embedded) : getVariableValue('title', d._embedded)}}
              div.font-weight-thin(style="margin-bottom:8px;") {{locale === 'kk' ? getVariableValue('title2Kaz', d._embedded) : getVariableValue('title2', d._embedded)}}
      v-divider.mt-1(v-if="index + 1 < news.length")
    template(v-if="length > 1")
      v-divider
      v-card-actions
        v-pagination.mt-2(v-model="page.current" :length="length" :total-visible="6" v-if="total > page.per && news")
  </template>
  
  <script>
  import { mapGetters, mapActions } from 'vuex'
  import { getLocale } from '@/i18n'
  
  
  export default {
    name: 'NewsList',
  
    components: {
    },
  
    data() {
      return {
      }
    },
  
    computed: {
      ...mapGetters({
        news: 'task/news',
        total: 'task/newsTotal',
        page: 'task/newsPage',
      }),
      length() {
        return Math.ceil((this.total / this.page.per))
      },
      locale() {
        return getLocale()
      },
    },
  
    watch: {
      'page.current'(newValue) {
        this.paginateNews(newValue)
      }
    },

    created() {
      this.getNews()
    },
  
    methods: {
      ...mapActions({
        paginateNews: 'task/paginateNews',
        getNews: 'task/getNews',
      }),

      format_date(value) { // 2022-07-18T15:40:56.994Z
        if (value) {
          return this.$moment(value).format('DD.MM.YYYY HH:mm')
        }
      },
      getVariableValue(name, content){
        let result = undefined;
        if(content){
          content.variable.forEach(element => {
            if(element.name === name){
              result = element.value;
            }
          });
        }
        return result;
      },
      openNews(id){
        this.$router.push('/news/' + id)
      }
    },
  }
  </script>
  
  <style lang="stylus">
  .preview-small-media-item
    width 100px
    height 100px
    display inline-block
    background url('/static/icons/loading_spinner.gif') center no-repeat
    transition transform 0.15s ease 0s
  </style>
  


// WEBPACK FOOTER //
// src/components/news/NewsList.vue